// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-form{
    display: flex;
    flex-direction: column;
    width:50%;
    gap:5px;
}
.add-form-buttons{
    display: flex;
    margin-top:10px;
    gap:10px;
    width:50%;
    justify-content:center;
}
.dlt{
    background: #ff4d4f;
    color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/AdminPanel/ReportsComponent/OtherReports.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,OAAO;AACX;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,SAAS;IACT,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".add-form{\n    display: flex;\n    flex-direction: column;\n    width:50%;\n    gap:5px;\n}\n.add-form-buttons{\n    display: flex;\n    margin-top:10px;\n    gap:10px;\n    width:50%;\n    justify-content:center;\n}\n.dlt{\n    background: #ff4d4f;\n    color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
